module.exports = __webpack_public_path__ + "img/63.f8441573.png";